import React from 'react'
import styled from 'styled-components'

export default ({ className, stroke = '#7A7A7A', ...rest }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_638_5538)">
        <path
          d="M12 1.33301L14.6667 3.99967"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.99968 13.6663L12.6663 5.99968L9.99968 3.33301L2.33301 10.9997L1.33301 14.6663L4.99968 13.6663Z"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_638_5538">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
